export default "__VITE_ASSET__BJorb0rA__"